module.exports = __webpack_public_path__ + "static/media/AI_16.9624e649.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AI_16.png
// module id = 131
// module chunks = 0